// Configuration for Kinora Public App with Supabase
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  USER_TYPE: 'viewer',
  ENDPOINTS: {
    // Backend API endpoints (for video content, etc.)
    VIDEOS: `${API_BASE_URL}/api/videos`,
    SERIES: `${API_BASE_URL}/api/series`,
    RECOMMENDATIONS: `${API_BASE_URL}/api/recommendations`
  },
  TIMEOUTS: {
    DEFAULT: 10000,
    UPLOAD: 30000
  }
};

// Supabase configuration
export const SUPABASE_CONFIG = {
  url: import.meta.env.VITE_SUPABASE_URL,
  anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
};

export default API_CONFIG;